export const urls = {
  ITEMS: 'https://sneakers-server-2hes.onrender.com/items',
  CART: 'https://sneakers-server-2hes.onrender.com/cart',
  FAVORITES: 'https://sneakers-server-2hes.onrender.com/favorites',
  ORDERS: 'https://sneakers-server-2hes.onrender.com/orders',
}
